import { IGenericCmsPage } from "api/interfaces/static-pages/common.type";
import Index from "container/contact-us/contact-us.container";

function ContactUs(props: IGenericCmsPage) {
  return <Index {...props} />;
}

export default ContactUs;
